export default {
  SET_PAGINATION(state, data) {
    state.pagination = data
  },
  SET_SUBMISSIONS(state, documents) {
    state.submissions = documents
  },
}
